const {
  GET_MARKET_LIST,
  GET_MARKET_LIST_FAILED,
  GET_MARKET_LIST_SUCCESS,
} = require('./actionTypes');

const initialState = {
  isLoadingMarketList: false,
  marketList: [],
  marketTotal: 0,
};

const market = (state = initialState, action) => {
  switch (action.type) {
    case GET_MARKET_LIST:
      return {
        ...state,
        isLoadingMarketList: true,
      };

    case GET_MARKET_LIST_SUCCESS:
      return {
        ...state,
        marketList: action.payload.append
          ? [...state.marketList, ...action.payload.data]
          : action.payload.data,
        marketTotal: action.payload.total,
        isLoadingMarketList: false,
      };

    case GET_MARKET_LIST_FAILED:
      return {
        ...state,
        isLoadingMarketList: false,
      };

    default:
      return state;
  }
};

export default market;
